import axios from '../../../../utils/api'

const actions = {
  async getItems ({ commit }) {
    const orgaosExpedidores = await axios({
      method: 'get',
      url: 'orgaoExpedidor/findAll'
    })
    return orgaosExpedidores
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/orgaosExpedidores.js